import { Navigate, useParams } from 'react-router-dom';

/**
 * 旧 URL 互換のためのリダイレクト。
 * /planner/projects/:projectId → /planner/project/:projectId
 * ナレッジ・週次出力等で生成されたリンクを正しいルートに転送する。
 */
export default function ProjectRedirect() {
  const { projectId } = useParams();
  if (!projectId) return <Navigate to="/planner" replace />;
  return <Navigate to={`/planner/project/${projectId}`} replace />;
}
